var map = {
	"./ban1.jpg": 2667,
	"./ban2.jpg": 5692,
	"./ban3.jpg": 953,
	"./ban4.jpg": 4490,
	"./ban5.jpg": 2007,
	"./ban6.jpg": 4728,
	"./coffret.jpg": 7368,
	"./coffret2.jpg": 1907,
	"./contact.jpg": 6271,
	"./couvertureProduct/BAKLEWA.jpg": 4184,
	"./couvertureProduct/CHOCOLAT.jpg": 2198,
	"./couvertureProduct/NAISSANCE.jpg": 3860,
	"./couvertureProduct/SALÉ.jpg": 5058
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7088;